module.exports = __webpack_public_path__ + "static/img/lista-aprobados-TDE-1.424ce81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lista-aprobados-TDE-1.jpg
// module id = HjB/
// module chunks = 9